export const GlobalStyles = {
  colors: {
    blue: "#002061",
    mustard: "#FFC000",
    white: "#FFFFFF",
    black: "#000000",
    red: "#cc3300",
    grey: "#E5E4E2",
    lightGrey: "#F5F4F2",
    green: "#4BB543",
    sideButton:"#f5f5f5",
    homeDivider:"#ffe16d",
    //gradient color
    gradientBlueStart: "#000561",
    gradientBlueEnd:   "#000AC7",
    statGradientTop: "rgba(0, 33, 105, 0.85)",
    statGradientBottom: "#00A4DF",
    linkBlue: "#2300EC",
    tableBorder: "#727272"
  },
  text: {
    fontFamily: "Inter-Regular",
  },
  card: {
    backgroundColor: 'white',
    borderRadius: 5,
    // padding: 16,
    
    shadowColor: 'black',
    shadowOffset: {
        width: 0,
        height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 14,
    width: "262px",
    height: "234px",
    // justifyContent: 'center',
    // alignItems: 'center',
},
header: {
    // marginBottom: 16,
    alignItems: 'center',
    backgroundColor:'#FFC00096',
    height:'70px',
    width:"262px",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    zIndex: -1,
  

},
title: {
    fontSize: 16,
    fontWeight: 500,
    color: '#000000',
    marginTop: 10,
},
text: {
    fontSize: 14,
    color: '#000000',
    marginTop: 15,
    textAlign: 'center',
},
content: {
    alignItems: 'center',
    paddingLeft:30,
    paddingRight:25,
},

};
